import TotalRaisedTicketIcon from "../../../assets/icons/TotalAssessmentIcon.svg";
import PendingTicketsIcon from "../../../assets/icons/pendingTicketIcon.svg";
import ResolvedTicketsIcon from "../../../assets/icons/ClosedTIcketIcon.svg";
import InProgressTicketsIcon from "../../../assets/icons/TotalTimeTakenIcon.svg";

const SupportStatCard = () => {
  const cards = [
    {
      icon: TotalRaisedTicketIcon,
      value: 1800,
      title: "Total Raised Tickets",
      bg: "#E6F4FF",
    },
    {
      icon: PendingTicketsIcon,
      value: 600,
      title: "Pending Tickets",
      bg: "#EAF7EA",
    },
    {
      icon: ResolvedTicketsIcon,
      value: 800,
      title: "Resolved Tickets",
      bg: "#F1F0FF",
    },
    {
      icon: InProgressTicketsIcon,
      value: 400,
      title: "In Progress Tickets",
      bg: "#F2F3FF",
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      {cards.map((card, index) => (
        <div
          key={index}
          className="
            h-[157px]
            rounded-lg
            bg-white dark:bg-slate-800
            border border-slate-200 dark:border-slate-700
            shadow
            flex items-center justify-center
          "
        >
          <div className="flex items-center gap-3">
            {/* Icon */}
            <div
              className="flex items-center justify-center rounded-full flex-shrink-0"
              style={{
                width: 80,
                height: 80,
                backgroundColor: card.bg,
              }}
            >
              <img
                src={card.icon}
                alt={card.title}
                className="w-12 h-12 object-contain"
              />
            </div>

            {/* Text */}
            <div>
              <h4 className="text-2xl font-semibold text-slate-900 dark:text-slate-100 leading-tight">
                {card.value}
              </h4>
              <p className="text-sm mt-1 text-slate-800 dark:text-slate-400">
                {card.title}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SupportStatCard;